export const FILE_REMOVE = "remove-file";
export const EXISTING_FILE_REMOVE = "remove-existing-file";
